import type { SelectorOption } from '../../../Components';

export const TEXT_ONLY_LAYOUT_VALUE = 'textonly';
export const PPAG_USE_CASE_ID = 'PPAGAutoLayouts';
export const PPAG_TEXT_ONLY_USE_CASE_ID = 'PPAGTextOnlyAutoLayouts';

export const PPAG_LAYOUT_OPTIONS: SelectorOption[] = [
    { value: '', label: 'All Layouts (Default)' },
    { value: 'stackCentered', label: 'Stack Centered' },
    { value: 'doubleCurvedStackCentered', label: 'Double Curved Stack Centered' },
    { value: 'curvedStackCentered', label: 'Curved Stack Centered' },
    { value: 'iconLast', label: 'Icon Last' },
    { value: 'iconSecond', label: 'Icon Second' },
    { value: TEXT_ONLY_LAYOUT_VALUE, label: 'Text Only' },
];
